// @flow
import React from "react";
import styled from "styled-components";

const Icon = styled.span`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  margin-left: ${props => (props.theme.direction === "rtl" ? "5px" : 0)};
`;

const IconSvg = styled.svg`
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
`;

const PopupIcon = styled(IconSvg)`
  position: relative;
  margin-top: -2px;
  margin-right: 0px;
`;

export const VerifiedIcon = props => (
  <Icon style={{ margin: 0, verticalAlign: "middle" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.094"
      height="16.125"
      viewBox="0 0 16.094 16.125"
      fill="#3B9478"
      fillRule="evenodd"
    >
      <path
        d="M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm4.621,6.053-4.318,4.318,0.013,0.013-1.305,1.306-3.3-3.3,1.305-1.306,1.978,1.978,4.317-4.318Z"
        transform="translate(-241.969 -378.938)"
      />
    </svg>
  </Icon>
);

export const UnverifiedIcon = props => (
  <Icon style={{ margin: 0, verticalAlign: "middle" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.094"
      height="16.125"
      viewBox="0 0 16.094 16.125"
      fill="#e74c3c"
      fillRule="evenodd"
    >
      <path
        d="M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z"
        transform="translate(-241.969 -378.938)"
      />
    </svg>
  </Icon>
);

export const WarningIcon = props => (
  <Icon style={{ margin: 0, verticalAlign: "middle" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill={props.color || "#d05353"}
      fillRule="evenodd"
    >
      <g transform="translate(-400.999 -569.95)">
        <path
          d="M17.7,42.525,10.62,30.759A2.1,2.1,0,0,0,7,30.768L.3,42.52a2.121,2.121,0,0,0,1.812,3.209H15.886A2.121,2.121,0,0,0,17.7,42.525ZM8.811,43.607a1.061,1.061,0,1,1,1.055-1.061A1.059,1.059,0,0,1,8.811,43.607ZM9.88,38.3a1.071,1.071,0,0,1-1.069,1.061A1.053,1.053,0,0,1,7.764,38.3V34.061A1.053,1.053,0,0,1,8.811,33,1.071,1.071,0,0,1,9.88,34.061Z"
          transform="translate(400.999 540.221)"
        />
      </g>
    </svg>
  </Icon>
);

export const PendingIcon = props => (
  <Icon style={{ margin: 0, verticalAlign: "middle" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.094"
      height="16.125"
      viewBox="0 0 16.094 16.125"
      fill="#e7d23c"
      fillRule="evenodd"
    >
      <path
        d="M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z"
        transform="translate(-241.969 -378.938)"
      />
    </svg>
  </Icon>
);

export const PhoneIcon = () => (
  <PopupIcon
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="#cccccc"
  >
    <path d="M0.8,11.663l6.4,6.4a1.055,1.055,0,0,0,1.492,0l9.569-9.569a1.055,1.055,0,0,0,0-1.492l-6.4-6.4a1.055,1.055,0,0,0-1.492,0L0.8,10.17A1.055,1.055,0,0,0,.8,11.663Zm4.169,2.206a0.664,0.664,0,1,1,.939,0A0.664,0.664,0,0,1,4.968,13.869ZM10.685,2.69a0.29,0.29,0,0,1,.411,0l5.075,5.076a0.29,0.29,0,0,1,0,.411L9.9,14.45a0.29,0.29,0,0,1-.411,0L4.411,9.375a0.291,0.291,0,0,1,0-.411L10.685,2.69h0Z" />
  </PopupIcon>
);

export const MailIcon = () => (
  <PopupIcon
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="14"
    viewBox="0 0 19 14"
    fill="#cccccc"
  >
    <path d="M17.7,0.491H1.313a0.819,0.819,0,0,0-.819.819V13.187a0.819,0.819,0,0,0,.819.819H17.7a0.819,0.819,0,0,0,.819-0.819V1.31A0.819,0.819,0,0,0,17.7.491ZM2.133,3.1L6.891,7.228,2.133,11.352V3.1ZM9.507,7.327l-6-5.2h12ZM8.139,8.31L8.971,9.03a0.819,0.819,0,0,0,1.073,0l0.831-.72,4.684,4.057H3.455Zm3.985-1.082L16.882,3.1v8.248Z" />
  </PopupIcon>
);

export const InfoIcon = ({ fill }) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill={fill || "#b5b5b5"}
    fillRule="evenodd"
  >
    <path
      d="M247.01,200.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,247.01,200.952Zm-1,4.038h2.006v1.975h-2.006V204.99Zm2.978,7.969H245v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z"
      transform="translate(-238.016 -200)"
    />
  </IconSvg>
);

export const DateIcon = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="#a5a4a4"
    fillRule="evenodd"
  >
    <path
      d="M609.988,389h3v2.967h-3V389Zm13.018-5.97V381h-2v2.027h-9.02V381h-1.97v2.027H606V401h21.014V383.025h-4.008Zm2,15.932H608V384.972h2.017v1.015h1.97v-1.015h9.02v1.015h2v-1.015h2v13.985ZM619.988,389h3v2.967h-3V389Zm-5,0h3v2.967h-3V389Zm-5,5h3v2.967h-3V394Zm10,0h3v2.967h-3V394Zm-5,0h3v2.967h-3V394Z"
      transform="translate(-606 -381)"
    />
  </IconSvg>
);

export const TimeIcon = ({ onUp, onDown, ...props }) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="#717171"
    fillRule="evenodd"
    {...props}
  >
    <path
      d="M616.008,465.952l-4.037-5.012h8.075l-4.038,5.012"
      transform="translate(-606 -444.938)"
      onClick={() => typeof onDown === "function" && onDown()}
    />
    <path
      d="M616.008,444.923l-4.037,5.012h8.075l-4.038-5.012"
      transform="translate(-606 -444.938)"
      onClick={() => typeof onUp === "function" && onUp()}
    />
  </IconSvg>
);

export const TimeIconUp = ({ onClick, ...props }) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="15"
    viewBox="0 -5 21 15"
    fill="#717171"
    fillRule="evenodd"
    {...props}
    onClick={onClick}
  >
    <path
      d="M616.008,444.923l-4.037,5.012h8.075l-4.038-5.012"
      transform="translate(-606 -444.938)"
    />
  </IconSvg>
);

export const TimeIconDown = ({ onClick, ...props }) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="15"
    viewBox="0 10 21 15"
    fill="#717171"
    fillRule="evenodd"
    {...props}
    onClick={onClick}
  >
    <path
      d="M616.008,465.952l-4.037-5.012h8.075l-4.038,5.012"
      transform="translate(-606 -444.938)"
    />
  </IconSvg>
);

export const TimefaceIcon = () => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    width="20.031"
    height="20.031"
    viewBox="0 0 20.031 20.031"
    fill="#a5a4a4"
    fillRule="evenodd"
  >
    <path
      d="M287.977,546.042A8.019,8.019,0,1,1,296,538.023a8.042,8.042,0,0,1-8.018,8.019m0-18.042A10.024,10.024,0,1,0,298,538.023,10.053,10.053,0,0,0,287.977,528m0.5,5.012h-1.5v6.014l5.212,3.207,0.8-1.3-4.51-2.706v-5.212"
      transform="translate(-277.969 -528)"
    />
  </IconSvg>
);



// WEBPACK FOOTER //
// ./src/components/Icons.js